export class HotelModel {
  name = "";
  name_ar = "";
  isMakkah = null;
}
